"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAndModifyProperty = exports.rbiPrefixToPaycomet = exports.keysToReplace = void 0;
//toLowerCase() will be applied to the searched key
exports.keysToReplace = ['order', 'rbiorderid'];
exports.rbiPrefixToPaycomet = 'RB';
const prefixLength = 2;
/**
 *
 * @param {any} obj - Original object to which the prefix is removed or added in the requested properties
 * @param {string[]} properties - Properties to replace that should be searched for in the object
 * @param {boolean} withPrefix - If true, the prefix will be added, if false, the prefix will be removed.
 * @returns {void} It does not return any value, it only modifies the original object.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function findAndModifyProperty(obj, properties, withPrefix) {
    if (obj === null || typeof obj !== 'object') {
        return;
    }
    for (const key of Object.keys(obj)) {
        if (properties.includes(key.toLocaleLowerCase())) {
            const value = obj[key];
            if (withPrefix) {
                if (typeof value === 'string') {
                    obj[key] = `${exports.rbiPrefixToPaycomet}${value}`;
                }
            }
            else if (typeof value === 'string' && value.startsWith(exports.rbiPrefixToPaycomet)) {
                obj[key] = value.substring(prefixLength);
            }
        }
        if (typeof obj[key] === 'object') {
            findAndModifyProperty(obj[key], properties, withPrefix);
        }
    }
}
exports.findAndModifyProperty = findAndModifyProperty;
//# sourceMappingURL=order-prefix.js.map